import { Group, Text } from '@mantine/core';
import Link from 'next/link';
import ExternalLinkIcon from '@/icons/external-link.svg';

type PublishLinkProps = {
  url: string;
};

export const PublishedLink = ({ url }: PublishLinkProps) => {
  return (
    <Link href={url} style={{ textDecoration: 'none' }} target='_blank'>
      <Group wrap='nowrap'>
        <Text fs='14px' fw='400' c='gray.6'>
          {url}
        </Text>
        <ExternalLinkIcon style={{ width: 20, height: 20, color: 'transparent' }} />
      </Group>
    </Link>
  );
};
